import { z } from "zod";
import {
  CatalogItemSchema,
  CommunityProjectSchema,
  GiftSchema,
  MoneySchema,
  NeighbourHomeSchema,
  PropertyStateSchema,
  QuestTemplateSchema,
  WorldStateSchema
} from "@tribe/domain";

export const ActivityBootstrapSchema = z.object({
  guild: z.object({ id: z.string(), name: z.string(), isModerator: z.boolean() }),
  member: z.object({ id: z.string(), displayName: z.string(), avatarUrl: z.string().optional() }),
  wallet: MoneySchema,
  property: PropertyStateSchema,
  // Defaulted, so a worker that has not shipped neighbours yet still parses.
  neighbours: z.array(NeighbourHomeSchema).default([]),
  world: WorldStateSchema,
  catalog: z.array(CatalogItemSchema),
  ownedItemIds: z.array(z.string()),
  activeQuests: z.array(QuestTemplateSchema),
  project: CommunityProjectSchema,
  gifts: z.array(GiftSchema),
  rewardInbox: z.array(z.object({ id: z.string(), label: z.string(), copper: z.number().int().nonnegative(), projectEffort: z.number().int().nonnegative(), createdAt: z.string() }))
});
